import * as React from "react";
import MuiModal from "@mui/material/Modal";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Label, ErrorText, TextInput, Btn, Spinner } from "./form/FormControls";
import { FieldGroup } from "./form/Form.styles";
import { DialogBox, DialogTitle } from "./form/Modal.styles";

const initialValues = {
  name: "",
  email: ""
};

const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().required("Email value is required")
});

const BasicModal = ({ open, setOpen, onSubmit }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <MuiModal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <DialogBox>
        <DialogTitle>Share data via email</DialogTitle>
        <Formik
          initialValues={initialValues}
          validationSchema={ValidationSchema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={onSubmit}>
          {({ values, errors, touched, isSubmitting, handleChange, setFieldError }) => (
            <Form>
              <FieldGroup>
                <Label htmlFor="name">Name</Label>
                <TextInput
                  id="name"
                  name="name"
                  autoFocus
                  value={values.name}
                  invalid={!!(errors.name && touched.name)}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldError("name", undefined);
                  }}
                />
                {errors.name && touched.name && <ErrorText>{errors.name}</ErrorText>}
              </FieldGroup>

              <FieldGroup spacing={28}>
                <Label htmlFor="email">Email</Label>
                <TextInput
                  id="email"
                  name="email"
                  type="email"
                  value={values.email}
                  invalid={!!(errors.email && touched.email)}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldError("email", undefined);
                  }}
                />
                {errors.email && touched.email && <ErrorText>{errors.email}</ErrorText>}
              </FieldGroup>

              <Btn type="submit" full disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <Spinner />
                    Submitting
                  </>
                ) : (
                  "Send"
                )}
              </Btn>
            </Form>
          )}
        </Formik>
      </DialogBox>
    </MuiModal>
  );
};

export default BasicModal;
